import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminNewsletterConfigsNewsletterConfigRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ newsletter_config_id }) {
    const { content } = await this.store.request(
      findRecord('newsletter-config', newsletter_config_id),
    );

    return content.data;
  }

  async afterModel(model) {
    this.breadcrumb.registerDetailRoute(await model.artist);
    this.breadcrumb.registerDetailRoute(model, {
      recordExplorerModelName: 'artist',
    });
  }
}
